import React from 'react';

import Link from "@mui/joy/Link";
import {Card, CircularProgress} from "@mui/joy";

// components
import BaseApi from "../../utils/BaseApi";
import {b64toBlob, downloadBlob} from "../../utils/misc";

// icons
import AttachFileIcon from '@mui/icons-material/AttachFile';


class MessageCommonAttachment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            download: false,
        }
    }

    async retrieveContent(){
        const url = `message/${this.props.message.id}/download`;
        const api = new BaseApi();
        let params = {};
        let response = await api.get(
            url,
            params
        );
        return response.data.content
    }

    async download(){
        this.setState({
            download: true
        })
        let content = await this.retrieveContent()
        downloadBlob(
            b64toBlob(content),
            this.props.message.uploadname,
            ''
        )
        this.setState({
            download: false
        })
    }

    render() {
        return (
            <Card
                size={'sm'}
                variant={'soft'}
                sx={{
                    borderRadius: '16px',
                }}
                orientation={'horizontal'}
            >
                <AttachFileIcon
                    sx={{
                        fontSize: '20px'
                    }}
                />
                <Link
                    onClick={this.download.bind(this)}
                    noWrap
                >
                    {this.props.message.uploadname}
                </Link>
                {
                    this.state.download?
                        <CircularProgress
                          size="sm"
                        />:
                        null
                }
            </Card>
        )
    }
}

export default MessageCommonAttachment

